import { Component, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { formatTimeBasedOnTimezone } from '../../../core/utils/date-time.util';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { NotificationsComponent } from '@edtech-ui/dashboard/teacher/inbox/notifications/notifications.component';
import { MatDialog } from '@angular/material/dialog';
import { StatusBadgeComponent } from '@edtech-ui/shared/status-badge/status-badge.component';
import { MentorRescheduleDialogComponent } from '../mentor-reschedule-dialog/mentor-reschedule-dialog.component';
import { MentorSessionCancelDialogComponent } from '../mentor-session-cancel-dialog/mentor-session-cancel-dialog.component';
import { SessionTypeEnum } from '@edtech-ui/constants/session-type.enum';
import { SessionMeetingStatus } from '@edtech-ui/constants/session-meeting-status.enum';
import { GetUpcomingSessionBooking } from '@edtech-ui/core/models/mentors-sessions/get-mentor-upcoming-session';
import { MentorService } from '@edtech-ui/core/services/mentor-management/mentor.service';
import { catchError, finalize, of, Subscription, tap } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { PaymentService } from '@edtech-ui/core/services/payment-management/payment.service';
import { PaymentHistory } from '@edtech-ui/core/models/mentors-sessions/get-payment-history';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MentorSessionPaymentBookingStatus } from '@edtech-ui/constants/mentor-booking-payment.enum';
import { MentorSeesionUpComingstatusLabel, MentorSessionPaymentStatusLabel } from '@edtech-ui/core/models/mentors-sessions/mentor-session-payment-status-label';
import { IstUtcDatePipe } from '@edtech-ui/core/pipes/utc-time-format.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RazorPaymentPayload } from '@edtech-ui/core/models/mentors-sessions/create-order-razorpay';
import { RazorPaymentVerifyPayload } from '@edtech-ui/core/models/mentors-sessions/post-razor-payment-verify';
import { MentorBookingPayload } from '@edtech-ui/core/models/mentors-sessions/post-booking-session';
import { MentorReviewConfirmDialogComponent } from '../mentor-review-confirm-dialog/mentor-review-confirm-dialog.component';
import { environment } from 'environments/environment';
import { DateService } from '@edtech-ui/core/services/dateService/date.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissionForStudents } from '@edtech-ui/access-role-permissions/users-permissions-constants/student-roles-permissions.enum';
import { HasPermissionDirective } from '@edtech-ui/access-role-permissions/users-permissions-directives/has-permissions.directives';
import { AuthServiceService } from '@edtech-ui/core/services/authService/auth-service.service';
declare var Razorpay: any;

@Component({
	selector: 'app-mentor-my-session',
	standalone: true,
	imports: [CommonModule, MatTabsModule, MatCardModule, MatIconModule, MatButtonModule, ReactiveFormsModule,
		NotificationsComponent, IstUtcDatePipe, MatProgressSpinnerModule, MatTooltipModule, HasPermissionDirective,
		StatusBadgeComponent
	],
	templateUrl: './mentor-my-session.component.html',
	styleUrls: ['./mentor-my-session.component.scss']
})
export class MentorMySessionComponent implements OnInit, OnDestroy {

	isNotificationOpen = false;
	isMobileMenuOpen = false;
	isSessionLoading = false;
	isHistoryLoading = false;
	isPaymentHistory = false;
	isLoadMoreLoading = false;
	isLoadingRefund = false;
	refundButtonLoadingIndex: number | null = null;
	searchQuery = '';
	totalNotifications: number = 0;
	pageLimit = 10;
	pageNo: number = 1;
	totalPages = 0;
	upcomingSessionCount: number = 0;
	historyCount: number = 0;
	paymentCount: number = 0;
	totalPaymentAmount: number = 0
	cancelCount: number = 0;
	subscription = new Subscription();
	mentorSession: GetUpcomingSessionBooking[] = [];
	mentorPayment: PaymentHistory[] = [];
	mentorHistory: GetUpcomingSessionBooking[] = [];
	cancelSession: GetUpcomingSessionBooking[] = [];
	selectedTab: SessionTypeEnum = SessionTypeEnum.Upcoming;
	SessionTypeEnum = SessionTypeEnum;
	sessionMeetingStatus = SessionMeetingStatus;
	MentorSessionPaymentBookingStatus = MentorSessionPaymentBookingStatus;
	MentorSessionPaymentStatusLabel = MentorSessionPaymentStatusLabel;
	MentorSeesionUpComingstatusLabel = MentorSeesionUpComingstatusLabel;
	@ViewChild(NotificationsComponent) notificationsChild!: NotificationsComponent;
	studentName = '';
	amountCost: number = 0;
	isPaymentProcessing: boolean = false;
	dateFormat = DateService.APP_DATE_TIME_SHORT;
	studentEmail: string | null = null;
	completed_count: number = 0;
	currentBookingId: string | null = null;
	currentMentorId: string | null = null;
	currentAmount: number = 0;
	showCancelButton: boolean = false;
	isHistoryLoadMoreLoading = false;
	isCancelLoadMoreLoading = false;
	isPaymentLoadMoreLoading = false;
	historytPageNo = 1;
	historyTotalPages = 0;
	cancelPageNo = 1;
	cancelTotalPages = 0;
	paymentPageNo = 1;
	paymentTotalPages = 0;
	activeTab = 'all';
	PermissionForStudents = PermissionForStudents;

	toggleMobileMenu() {
		this.isMobileMenuOpen = !this.isMobileMenuOpen;
	}

	closeMobileMenu() {
		this.isMobileMenuOpen = false;
	}

	constructor(
		private dialog: MatDialog,
		private _mentorService: MentorService,
		private _toastr: ToastrService,
		private _paymentService: PaymentService,
		private ngZone: NgZone,
		private router: Router,
		private route: ActivatedRoute,
		private _authService: AuthServiceService
	) {
	}

	ngOnInit(): void {

		if (this._authService.hasPermission(PermissionForStudents.MENTOR_SESSIONS)) {
			this.getUpcomingMentorSession();
			this.getAllMentorHistory();
		}

		if (this._authService.hasPermission(PermissionForStudents.PAYMENTS_VIEW)) {
			this.getCompleteHistoryPayment();
		}

		if (this._authService.hasPermission(PermissionForStudents.MENTOR_CANCELLATION)) {
			this.getMentorCancelled();
		}
		this.studentName = this._mentorService.studentName.getValue();
		this.studentEmail = localStorage.getItem('email');

		this.route.queryParams.subscribe(params => {
			const tab = params['tab'];
			this.selectedTab = this.mapTabToEnum(tab);
		});
	}

	selectTab(tab: SessionTypeEnum) {
		this.selectedTab = tab;
		this.closeMobileMenu();
	}

	openNotifications() {
		this.isNotificationOpen = !this.isNotificationOpen;
	}

	updateTotalNotifications(count: number) {
		this.totalNotifications = count;
	}

	markAllNotificationsRead() {
		if (this.notificationsChild) {
			this.notificationsChild.markAllNotificationsAsRead();
		}
	}

	openRescheduleDialogBox(mentor: GetUpcomingSessionBooking) {
		this.dialog.open(MentorRescheduleDialogComponent, {
			data: {
				booking_id: mentor.booking_id,
				mentor_name: mentor.mentor_name,
				session_type: mentor.session_type,
				start_time: mentor.start_time || mentor.appointment_datetime_utc,
				end_time: mentor.end_time || mentor.end_datetime_utc,
				appointment_date: mentor.appointment_date || mentor.appointment_datetime_utc
			}
		})
	}

	openSessionCancelDialogBox(mentor: GetUpcomingSessionBooking) {
		const dialogRef = this.dialog.open(MentorSessionCancelDialogComponent, {
			data: {
				booking_id: mentor.booking_id,
				mentor_name: mentor.mentor_name,
				session_type: mentor.session_type,
				appointment_datetime_utc: mentor.appointment_datetime_utc,
				end_datetime_utc: mentor.end_datetime_utc,
			}
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result === true) {
				this.pageNo = 1;
				this.getUpcomingMentorSession();
				this.getMentorCancelled();
			}
		});
	}

	getUpcomingMentorSession(loadMore = false) {
		if (loadMore) {
			this.isLoadMoreLoading = true;
			this.pageNo++;
		} else {
			this.isSessionLoading = true;
			this.pageNo = 1;
		}
		this.subscription.add(
			this._mentorService.getUpcomingMentorSession(this.pageNo, this.pageLimit).pipe(
				tap(response => {
					if (response.Success) {
						this.totalPages = response.Data.total_pages;
						this.upcomingSessionCount = response.Data.total_count;
						const normalizedBookings = response.Data.bookings.map((b: any) => {
							if (b.status) b.status = b.status.toLowerCase().trim();
							return b;
						});

						if (loadMore) {
							this.mentorSession = [...this.mentorSession, ...normalizedBookings];
						} else {
							this.mentorSession = normalizedBookings;
						}
					} else {
						this._toastr.error(response.Message);
					}
				}),
				finalize(() => {
					this.isLoadMoreLoading = false;
					this.isSessionLoading = false;
				}),
				catchError(() => {
					this._toastr.error('Something went wrong while fetching the upcoming bookings');
					return of(null);
				}),
			).subscribe()
		);
	}

	getUserNameInitials(name: string): string {
		if (!name) return '';
		return name
			.split(' ').map(word => word[0]).join('').toUpperCase();
	}

	getCompleteHistoryPayment(loadMore = false) {
		if (loadMore) {
			this.isPaymentLoadMoreLoading = true;
			this.paymentPageNo++;
		} else {
			this.isPaymentHistory = true;
			this.paymentPageNo = 1;
		}
		this.subscription.add(
			this._paymentService.getCompleteHistoryPayment(this.paymentPageNo, this.pageLimit).pipe(
				tap(response => {
					if (response.Success) {
						this.paymentTotalPages = response.Data.payments.total_pages;
						this.paymentCount = response.Data.payments.total_count
						this.totalPaymentAmount = response.Data.payments.total_amount;
						if (loadMore) {
							this.mentorPayment = [...this.mentorPayment, ...response.Data.payments.payments]
						} else {
							this.mentorPayment = response.Data.payments.payments;
						}
					} else {
						this._toastr.error(response.Message);
					}
				}),
				finalize(() => {
					this.isPaymentHistory = false;
					this.isPaymentLoadMoreLoading = false;
				}),
				catchError(() => {
					this._toastr.error('Something went wrong while fetching the upcoming bookings');
					return of(null);
				}),
			).subscribe()
		);
	}

	getAllMentorHistory(loadMore = false) {
		if (loadMore) {
			this.isHistoryLoadMoreLoading = true;
			this.historytPageNo++;
		} else {
			this.isHistoryLoading = true;
			this.historytPageNo = 1;
		}
		this.subscription.add(
			this._mentorService.getAllMentorSessionHistory(this.historytPageNo, this.pageLimit).pipe(
				tap(response => {
					if (response.Success) {
						this.historyTotalPages = response.Data.total_pages;
						this.historyCount = response.Data.total_count;
						this.completed_count = response.Data.completed_count;

						const normalizedHistory = response.Data.bookings.map((b: any) => {
							if (b.status) b.status = b.status.toLowerCase().trim();
							return b;
						});

						if (loadMore) {
							this.mentorHistory = [...this.mentorHistory, ...normalizedHistory];
						} else {
							this.mentorHistory = normalizedHistory;
						}

					} else {
						this._toastr.error(response.Message || 'Failed to load session history');
					}
				}),
				finalize(() => {
					this.isHistoryLoadMoreLoading = false;
					this.isHistoryLoading = false;
				}),
				catchError(() => {
					this._toastr.error('Something went wrong while fetching the session history');
					return of(null);
				}),
			).subscribe()
		);
	}

	joinSession(link: string | null | undefined) {
		if (link) {
			window.open(link, "_blank");
		} else {
			this._toastr.warning("No meeting link found");
		}
	}


	getMentorCancelled(loadMore = false) {
		if (loadMore) {
			this.isCancelLoadMoreLoading = true;
			this.cancelPageNo++;
		} else {
			this.isSessionLoading = true;
			this.cancelPageNo = 1;
		}
		this.subscription.add(
			this._mentorService.getMentorCancelledRefund(this.cancelPageNo, this.pageLimit).pipe(
				tap(response => {
					if (response.Success) {
						this.cancelTotalPages = response.Data.total_pages;
						this.cancelCount = response.Data.total_count;
						if (loadMore) {
							this.cancelSession = [...this.cancelSession, ...response.Data.bookings];
						} else {
							this.cancelSession = response.Data.bookings;
						}
					} else {
						this._toastr.error(response.Message);
					}
				}),
				finalize(() => {
					this.isCancelLoadMoreLoading = false;
					this.isSessionLoading = false;
				}),
				catchError(() => {
					this._toastr.error('Something went wrong while fetching the upcoming bookings');
					return of(null);
				}),
			).subscribe()
		);
	}


	postRefundPayment(bookingId: string, index: number) {
		this.refundButtonLoadingIndex = index;
		this.isLoadingRefund = true;
		this.subscription.add(
			this._mentorService.postRefundpayment(bookingId).pipe(
				tap(response => {
					if (response.Success) {
						this._toastr.success(response.Message);
						this.getMentorCancelled();
					} else {
						this._toastr.error(response.Message);
					}
				}),
				finalize(() => {
					this.refundButtonLoadingIndex = null;
					this.isLoadingRefund = false;
				}),
				catchError(() => {
					this._toastr.error('Something went wrong');
					return of(null);
				}),
			).subscribe()
		);
	}

	postRazorPayment(productId: string, pricingId: string, bookingId: string, amount: number, mentorId: string) {
		this.currentBookingId = bookingId;
		this.currentMentorId = mentorId;
		this.currentAmount = amount;

		const paylod: RazorPaymentPayload = {
			product_id: productId,
			pricing_id: pricingId,
			quantity: 1,
			booking_id: bookingId,
			mentor_id: mentorId
		}
		this.subscription.add(
			this._paymentService.postCreateOrderRazorPayment(paylod).pipe(
				tap(response => {
					if (response.Success) {
						this.isPaymentProcessing = true;
						this._paymentService.orderId.next(response.Data.order_id);
						this._paymentService.razorpayOrderId.next(response.Data.razorpay_order_id);
						this.openRazorPayDialogBox(response.Data.razorpay_order_id);
					} else {
						this._toastr.error(response.Message);
					}
				}),
				catchError(() => {
					this._toastr.error('Something went wrong. Please try again');
					return of(null);
				}),
			).subscribe()
		)
	}

	openRazorPayDialogBox(currentRazorpayOrderId: string) {
		const options: any = {
			key: environment.razorPayKey,
			amount: this.currentAmount * 100,
			currency: 'INR',
			name: `${this.studentName}`,
			description: 'Mentor Session Payment',
			order_id: currentRazorpayOrderId,
			prefill: {
				name: this.studentName,
				email: this.studentEmail,
			},
			theme: { color: '#3D348B' },
			handler: (response: any) => {
				this.ngZone.run(() => {
					this.postPaymentVerify(response);
				});
			}
		}

		const razorpay = new Razorpay(options);

		razorpay.on('payment.failed', (error: any) => {
			this._toastr.error('Payment failed. Please try again.');
		});
		razorpay.open();

	}

	postPaymentVerify(response: any) {

		const currentOrderId = this._paymentService.orderId.getValue();
		const currentRazorpayOrderId = this._paymentService.razorpayOrderId.getValue();

		const payload: RazorPaymentVerifyPayload = {
			razorpay_order_id: currentRazorpayOrderId,
			razorpay_payment_id: response.razorpay_payment_id,
			razorpay_signature: response.razorpay_signature,
			order_id: currentOrderId
		}

		this.subscription.add(
			this._paymentService.postRazorPaymentVerify(payload).pipe(

				tap(response => {
					if (response.Success) {
						this._paymentService.razorPayPaymentId.next(response.Data.razorpay_payment_id);
						this.postConfirmBookingSessionForm();
						this._toastr.success(response.Message);
					} else {
						this._toastr.error(response.Message);
					}
				}),
				catchError(() => {
					this._toastr.error('Something went wrong');
					return of(null);
				})
			).subscribe()
		)
	}

	postConfirmBookingSessionForm() {
		const bookingId = this.currentBookingId;
		const mentorId = this.currentMentorId;

		if (!bookingId || !mentorId) {
			this._toastr.error('Invalid booking or mentor ID');
			return;
		}

		const orderId = this._paymentService.orderId.getValue();

		const payloadTest: MentorBookingPayload = {
			booking_id: bookingId,
			order_id: orderId,
			mentor_id: mentorId
		}

		this.subscription.add(
			this._mentorService.postMentorSession(payloadTest).pipe(
				tap(response => {
					if (response.Success) {
						this.isPaymentProcessing = false;
						this._mentorService.saveConfirmBookingData.next(response.Data);
						this.OpenReviewBookingForm();
					} else {
						this._toastr.error(response.Message);
					}
				}),
				catchError(() => {
					this._toastr.error('Something went wrong while booking session form');
					return of(null);
				})
			).subscribe());
	}

	OpenReviewBookingForm() {
		const dialogRef = this.dialog.open(MentorReviewConfirmDialogComponent, {
			panelClass: 'review-booking-dialog',
			disableClose: true,
			data: { fromMentorPage: true }
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result === true) {
				this.pageNo = 1;
				this.getUpcomingMentorSession();
			}
		})
	}

	goBack() {
		this.router.navigate(['/student-dashboard/mentors']);
	}

	isJoinEnabled(mentor: GetUpcomingSessionBooking): boolean {
		if (
			mentor.status !== this.sessionMeetingStatus.Accepted ||
			!mentor.appointment_datetime_utc ||
			!mentor.end_datetime_utc
		) {
			return false;
		}

		const now = new Date();

		const sessionStart = this.parseBackendDateAsIST(mentor.appointment_datetime_utc);
		const sessionEnd = this.parseBackendDateAsIST(mentor.end_datetime_utc);

		const ENABLE_BEFORE_MINUTES = 5;

		const enableFrom = new Date(sessionStart.getTime() - ENABLE_BEFORE_MINUTES * 60 * 1000);

		return now >= enableFrom && now <= sessionEnd;
	}

	isCancellation(mentor: GetUpcomingSessionBooking): boolean {
		if (!mentor.cancellation_deadline_utc) return false;
		const now = new Date();

		const sessionStart = this.parseBackendDateAsIST(mentor.appointment_datetime_utc);
		const ENABLE_BEFORE_HOURS = 12;

		const twelveHoursBefore = new Date(sessionStart.getTime() - ENABLE_BEFORE_HOURS * 60 * 60 * 1000);

		return now <= twelveHoursBefore;
	}

	private parseBackendDateAsIST(dateStr: string): Date {
		if (!dateStr) return new Date(NaN);
		return new Date(dateStr);
	}

	mapTabToEnum(tab: string): SessionTypeEnum {
		switch (tab?.toLowerCase()) {
			case 'payment':
			case 'confirmed':
			case 'payment successful':
				return SessionTypeEnum.Payments;

			case 'cancelled':
			case 'rejected':
				return SessionTypeEnum.Cancelled;

			case 'upcoming':
			case 'accepted':
				return SessionTypeEnum.Upcoming;

			default:
				return SessionTypeEnum.Upcoming;
		}
	}

	formatTime(isoString: string | undefined): string {
		if (!isoString) return 'N/A';
		return formatTimeBasedOnTimezone(isoString);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}